import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { Location } from '@angular/common';
import { UserDetailsService } from '../../../api/userdetails/userdetails.service';
import { UserDetailModel } from '../../../api/userdetails/UserDetailModel';
import { WithdrawModel } from '../../../api/userdetails/withdrawModel';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'userdetail-page',
    templateUrl: './userdetail.html'
})
export class UserDetailComponent implements OnInit, OnDestroy {
    progressPer :string = "0%";
    sub;
    userID: string;
    type: string;
    isvisible: boolean;
    userDetail: UserDetailModel;
    userName: string;
    withdrawDetail: any;
    UserDownloadedAppList = [];
    
    drinkwaterlogDetail: any;
    drinkwater_logCounter : any = "";

    bettermelogDetail: any;
    betterme_logCounter : any = "";

    breathewelllogDetail: any;
    breathewell_logCounter : any = "";

    appassignDetail: any;
    message: string;
    constructor(private activatedRoute: ActivatedRoute, private router: Router, private userDetailsService: UserDetailsService, private location: Location) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            $(function () {

                $("[data-toggle=popover]").popover();
                $("[data-toggle=popover-hover]").popover({
                    trigger: 'hover'
                });
                $("[data-toggle=tooltip]").tooltip();
            });
            this.isvisible = false;
            this.userDetail = new UserDetailModel();
            this.initData();
        } else {
            this.router.navigate(['/']);
        }
    }
    initData() {
        this.sub = this.activatedRoute.params.subscribe(params => {
            this.userID = params['id1'];
            this.type = params['id2'];
            this.viewData(params['id2']);
        });
        $('.nav-item a').click(function () {
            $(this).addClass("active");
        }) 
    }
    formatOnlyDate(dateVal) 
    {
        var newDate = new Date(dateVal);
    
        var sMonth = this.padValue(newDate.getMonth() + 1);
        var sDay = this.padValue(newDate.getDate());
        var sYear = newDate.getFullYear();
        return sDay + "/" +sMonth + "/" + sYear;
      }
    formatDate(dateVal) 
    {
        var newDate = new Date(dateVal);
    
        var sMonth = this.padValue(newDate.getMonth() + 1);
        var sDay = this.padValue(newDate.getDate());
        var sYear = newDate.getFullYear();
        var sAMPM = this.formatAMPM(newDate);
        return sDay + "/" +sMonth + "/" + sYear + " " + sAMPM;
      }
      formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      }
      padValue(value) {
          return (value < 10) ? "0" + value : value;
      }
    viewData(type) {
        this.progressPer = "0%";
        this.type = type;
        if (type == "MORE") {
            if (this.userDetail.id == undefined) {
                this.UserDownloadedAppList = [];
                this.progressPer = "30%";
                this.userDetailsService.vUserDetails(this.userID).then(data => {
                    this.progressPer = "50%";
                    this.isvisible = data.status;
                    if (data.status) {
                        this.userDetail = data.data;
                        var _registerdate = this.formatDate(this.userDetail.registerdate);
                        var _lastactivedate = this.formatDate(this.userDetail.lastactivedate);

                        this.userDetail.registerdate = _registerdate;
                        this.userDetail.lastactivedate = _lastactivedate;

                        var _isupgradetopro = false;
                        var _ispremiumuser = false;
                        var _isprouser = false;
                        var _ispurchase = false;

                        if(this.userDetail.subscriptions != null && this.userDetail.subscriptions != undefined && this.userDetail.subscriptions != "")
                        {
                            var _subJSON = JSON.parse(this.userDetail.subscriptions);
                            if( _subJSON.subscriptions != undefined)
                            {
                                for (var key in _subJSON.subscriptions) 
                                {
                                if (_subJSON.subscriptions.hasOwnProperty(key)) 
                                {
                                    const element = _subJSON.subscriptions[key];
                                    if (element.key == "drinkwater") 
                                    {
                                        //ispremiumuser (Currently Active Subscription)
                                        //isprouser (Currently Pro User)
                                        //ispurchase (Anytime purchase)
                                        _ispremiumuser = element.value.ispremiumuser;
                                        _isprouser = element.value.isprouser;
                                        _ispurchase = element.value.ispurchase;
                                        _isupgradetopro = element.value.isupgradetopro;
                                    }
                                }
                                }
                            }
                        }
                        this.userDetail.ispremiumuser = _ispremiumuser;
                        this.userDetail.isprouser = _isprouser;
                        this.userDetail.ispurchase = _ispurchase;
                        this.userDetail.isupgradetopro = _isupgradetopro;

                        this.userName = data.data.firstname + " " + data.data.lastname;
                        this.userName = this.userName.trim();
                        this.UserDownloadedAppList = [];
                        if (data.data.appsublist != undefined && data.data.appsublist != null) {
                            var ssppp = data.data.appsublist.split(',');
                            for (let index = 0; index < ssppp.length; index++) {
                                const element = ssppp[index];
                                this.UserDownloadedAppList.push(element);
                            }
                        }
                    }
                    else {
                        $.notify({
                            message: data.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 500
                        });
                    }
                    this.progressPer = "100%";
                    this.progressTimeOut();
                })
            }
        }
        else if (type == "SUBSCRIPTION") {
        }
        else if (type == "DRINKWATER_LOGDATA") {
            this.progressPer = "30%";
            var jDaaa = {
                type : "drinkwater",
                userId : this.userID
            }
            this.userDetailsService.vLogDetail(jDaaa).then(data => {
                this.isvisible = data.status;
                this.drinkwaterlogDetail = data.data;
                this.drinkwater_logCounter = "("+this.drinkwaterlogDetail.length+")";
                this.progressPer = "50%";
                for (let index = 0; index < this.drinkwaterlogDetail.length; index++) {
                    const element = this.drinkwaterlogDetail[index];
                    this.drinkwaterlogDetail[index].logdate = this.formatOnlyDate(element.createdAt);
                }
                this.progressPer = "100%";
                this.progressTimeOut();
            })
        }
        else if (type == "BETTERME_LOGDATA") {
            this.progressPer = "30%";
            var jDaaa = {
                type : "peepooptracker",
                userId : this.userID
            }
            this.userDetailsService.vLogDetail(jDaaa).then(data => {
                this.isvisible = data.status;
                this.bettermelogDetail = data.data;
                this.betterme_logCounter = "("+this.bettermelogDetail.length+")";
                this.progressPer = "50%";
                for (let index = 0; index < this.bettermelogDetail.length; index++) {
                    const element = this.bettermelogDetail[index];
                    this.bettermelogDetail[index].logdate = this.formatOnlyDate(element.createdAt);
                }
                this.progressPer = "100%";
                this.progressTimeOut();
            })
        }
        else if (type == "BREATHEWELL_LOGDATA") {
            this.progressPer = "30%";
            var jDaaa = {
                type : "breathewell",
                userId : this.userID
            }
            this.userDetailsService.vLogDetail(jDaaa).then(data => {
                this.isvisible = data.status;
                this.breathewelllogDetail = data.data;
                this.breathewell_logCounter = "("+this.breathewelllogDetail.length+")";
                this.progressPer = "50%";
                for (let index = 0; index < this.breathewelllogDetail.length; index++) {
                    const element = this.breathewelllogDetail[index];
                    this.breathewelllogDetail[index].logdate = this.formatOnlyDate(element.createdAt);
                }
                this.progressPer = "100%";
                this.progressTimeOut();
            })
        }
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }
    backClicked() {
        this.location.back();
    }
    ngOnDestroy() {
        if (localStorage.getItem('id_token')) {
            this.sub.unsubscribe();
        } else {
            this.router.navigate(['/']);
        }
    }
    updateKey() {
        var uData = {
            id: this.userDetail.id,
            joincode: this.userDetail.joincode
        }
        this.userDetailsService.uDeviceUser(uData).then(data => {
            if (data.status == true) {
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                $.notify({
                    message: data.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
        })
    }
    deactiveUser() {
        var dataaa = 0;
        if (this.userDetail.isactive) {
            dataaa = 0;
        }
        else {
            dataaa = 1;
        }
        var dt =
        {
            isactive: dataaa
        }
        this.userDetailsService.DeactiveUser(this.userID, dt).then(data => {

            if (data.status == true) {
                this.userDetail.isactive = data.data
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                $.notify({
                    message: data.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/userdetail/userdetail.page.ts